import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { combineCompleteUrl } from 'app/common/utils/utils';
import { BaseHttpApiService } from 'app/services/api/base/base-http-api.service';
import { Observable } from 'rxjs';

@Injectable()
export class HttpApiService extends BaseHttpApiService {
	constructor(private readonly httpClient: HttpClient) {
		super();
	}

	public get<T>(
		url: string,
		data?: unknown,
		cancellationSubject?: Observable<void>,
		noncritical?: boolean
	): Observable<T> {
		return this.httpClient
			.get<T>(
				combineCompleteUrl(url, data),
				this.getRequestOptions(noncritical)
			)
			.pipe(this.applyCancellationSubject(cancellationSubject));
	}

	public post<T>(
		url: string,
		data?: object,
		cancellationSubject?: Observable<void>,
		noncritical?: boolean
	): Observable<T> {
		return this.httpClient
			.post<T>(
				combineCompleteUrl(url),
				data,
				this.getRequestOptions(noncritical)
			)
			.pipe(this.applyCancellationSubject(cancellationSubject));
	}

	public put<T>(
		url: string,
		data: object,
		cancellationSubject?: Observable<void>,
		noncritical?: boolean
	): Observable<T> {
		return this.httpClient
			.put<T>(
				combineCompleteUrl(url),
				data,
				this.getRequestOptions(noncritical)
			)
			.pipe(this.applyCancellationSubject(cancellationSubject));
	}

	public delete<T>(
		url: string,
		data: unknown,
		cancellationSubject?: Observable<void>,
		noncritical?: boolean
	): Observable<T> {
		return this.httpClient
			.delete<T>(
				combineCompleteUrl(url, data),
				this.getRequestOptions(noncritical)
			)
			.pipe(this.applyCancellationSubject(cancellationSubject));
	}
}
